import Vue from "vue"
import config from '../config'

export default {
    getUsers(params = {}) {
        return Vue.http.get(`${config.apiBaseUrl}/users`, { params }).then(res => res.json())
    }, 

    register(body){
        const authRequestBody = {
            'grant_type': 'password',
            'scope': 'all',
            'username': body.email,
            'password': body.password,
            'name': body.name
        }
        return Vue.http.post(config.apiBaseUrl + '/users/register', authRequestBody, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Basic OTg0NzAzNmUwYjY0ZTQ3NGNiZjRhOTdmY2MwYWNiMGQzZDE1NGFmMzpjYWY0Y2E5MDA5NzgyYmM5NmJlNjA0YTk3ZjBjYTAzNmVhOTg2YzE1'
            },
            emulateJSON: true
        }).then((response) => response.json());
    },
    update(body, userId, params = {}){
        return Vue.http.patch(config.apiBaseUrl + '/users/' + userId, body, { params }).then((response) => response.json());
    },
    simplifiedUpdate(body, userId, params = {}){
        return Vue.http.patch(config.apiBaseUrl + '/users/' + userId + '/simplified-update', body, { params }).then((response) => response.json());
    },
    remove(userId, params = {}){
        return Vue.http.delete(config.apiBaseUrl + '/users/' + userId, { params }).then((response) => response.json());
    },
    setDefaultCompanyId(companyId, params = {}){
        return Vue.http.patch(config.apiBaseUrl + '/users/set-company-id/' + companyId, { params }).then((response) => response.json());
    },

    setAvatarImage(body, userId, params = {}) {
        return Vue.http.post(config.apiBaseUrl + '/users/' + userId + '/avatar-image', body, { params }).then((response) => response.json());
    },

    createZepplinDeliveryman(userId, body, params = {}) {
        return Vue.http.post(config.apiBaseUrl + '/zepplin/users/' + userId + '/deliverymen', body, { params }).then((response) => response.json());
    }
}